import cn from 'classnames';

import './styles.scss';
import React from 'react';
import evieAvatar from '../../../../../../../../../assets/evie-avatar.svg';

type Props = {
  typing: boolean;
}

function Loader({ typing }: Props) {
  return (
    <div className={cn('loader', { active: typing })}>
      <div className="loader-avatar-wrapper">
        <img className="loader-avatar-img" src={evieAvatar} alt="Evie typing" />
      </div>
      <div className="loader-container">
        <span className="loader-dots"></span>
        <span className="loader-dots"></span>
        <span className="loader-dots"></span>
      </div>
    </div>
  );
}

export default Loader;
